const ColorPallet = {
 primaryBrown: "#A75B3B",
 primaryLightBrown: "#F3E3D3",
 secondLightBrown: "#BC785B",
 primaryDarkBrown: "#8B472B",
 primaryWhite: "#FFFFFF",
}

export default ColorPallet